export default {
  methods: {
    dispatchToast(detail) {
      document.dispatchEvent(new CustomEvent('converdySuperToast', {detail}));
    },
  },
};
